<template>
  <div class="page-container">
    <div class="sub-header" style="margin-bottom: 10px;">
      <h2>مراکز تعویض پلاک</h2>
    </div>
    <div class="background-color border-color img-header">
      <img
        src="../../assets/img/location-center.png"
        style="width: 100%"
        alt="location-center"
      />
    </div>

    <div
      class="text-color border-color background-color card"
      style="position: relative;"
    >
      <div v-if="!loader">
        <h3 class="textCenter" style="margin-top: 10px;">
          مراکز تعویض پلاک و شماره گذاری پلاک خودرو تهران
        </h3>
        <div class="description">
          ساعت کار مراکز تعویض پلاک و شماره گذاری
          <br />
          1- ساعت کار در استان تهران و تمامی مراکز استان‌ها، روزهای عادی، از
          شنبه تا چهارشنبه از ساعت 7 صبح شروع و در ساعت 14 به پایان می رسد.
          <br />
          2- این مراکز در روزهای پنجشنبه از ساعت 7 صبح الی 12 ظهر آماده خدمت
          رسانی به متقاضیان هستند
        </div>
      </div>
    </div>

    <plateReplacementCenterItem
      :plateReplacementCenter="item"
      v-for="item in items"
      :key="item.Id"
    >
    </plateReplacementCenterItem>

    <div class="error-message" v-if="!loader && errorMessage">
      {{ errorMessage }}
    </div>

    <div class="loader" v-if="loader">
      <div class="lds-ring">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../service";
import { mapActions } from "vuex";
import plateReplacementCenterItem from "../../components/carService/PlateReplacementCenterItem";

export default {
  name: "top-users",
  props: {},
  components: { plateReplacementCenterItem },
  data() {
    return {
      errorMessage: null,
      loader: false,
      items: [],
    };
  },
  methods: {
    ...mapActions(["setTheme", "setToken"]),
  },
  mounted: function() {
    if (this.$route.query.theme == "dark") {
      this.setTheme("dark");
    }
    if (this.$route.query.token) {
      this.setToken(this.$route.query.token);
    }
    this.loading = true;
    api
      .getPlateReplacementCenters({})
      .then((response) => {
        if (response.data && response.data.Status === 200) {
          this.items = response.data.Data;
        } else {
          if (
            response.data &&
            response.data.Messages &&
            response.data.Messages.length > 0
          ) {
            this.errorMessage = response.data.Messages[0];
          }
        }
      })
      .catch(() => {
        this.errorMessage =
          "متاسفانه خطای فنی رخ داده است؛ لطفا دوباره امتحان کنید.";
      })
      .finally(() => {
        this.loading = false;
      });
  },
};
</script>

<style scoped>
.img-header {
  width: 65px;
  border: 1px solid;
  padding: 11px;
  border-radius: 50%;
  height: 65px;
  z-index: 100;
  position: absolute;
  left: 0;
  right: 0;
  margin: auto;
}

.card {
  border: solid 1px;
  margin: 30px 10px 0 10px;
  border-radius: 5px;
  padding: 42px 12px 12px 12px;
  display: flex;
  flex-direction: column;
  border-bottom: solid 3px #09389f !important;
  position: relative;
}

.description {
  line-height: 28px;
  margin-top: 12px;
  text-align: justify;
}
</style>
